import { usePostHog } from 'posthog-js/react';
import isAnalyticsAllowed from '@/lib/isAnalyticsAllowed';
import { useCallback } from 'react';

export const useAnalytics = () => {
  const posthog = usePostHog();
  const trackEvent = useCallback((...args) => posthog?.capture(...args), [posthog]);

  if (!isAnalyticsAllowed) {
    return { trackEvent: () => {} };
  }

  return { trackEvent };
};
